// extracted by mini-css-extract-plugin
export default {"billTable":"vyapari-bill_billTable__THx2U","heading":"vyapari-bill_heading__MvX2y"};